import { useModuleBEM } from "@b2bportal/core-themes";
import { useFilterBags } from "@tenant/cars";
import { RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterBags.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent, type MinimumBagCount } from "~core-cars/types";

export type FilterBagsProps = {
  minimumBags: MinimumBagCount;
  onChange: (minimumBags: MinimumBagCount) => void;
  className?: string;
};

const COMPONENT_KEY = CoreCarsComponent.FilterBags;
export const FilterBags = ({
  minimumBags,
  onChange,
  className,
}: FilterBagsProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { options } = useFilterBags();

  return (
    <div className={clsx(className, block)}>
      <RadioGroup
        className={cn("radio-group")}
        options={options}
        onSelectValue={(v: string) => onChange(Number(v) as MinimumBagCount)}
        selectedOption={minimumBags.toString()}
      />
    </div>
  );
};
